import { DestinationFilterBase } from './destinationFilterBase';
import { TrackedPage } from '../trackedpages';
import { TrackedEvent } from '../trackedEvent';

export class IntercomDestinationFilter extends DestinationFilterBase {
    public destinationName = 'Intercom';

    public supportedEvents = [
        TrackedEvent.WorkspaceDeleted,
        TrackedEvent.UserAccountDeleted,
        // account deleted,
        // login,
        // email verified,
        TrackedEvent.UserSignedUp,
        TrackedEvent.SampleStorymapCreated,
        TrackedEvent.StorymapCreated,
        TrackedEvent.SubscriptionPurchased,
        TrackedEvent.SubscriptionUpgraded,
        TrackedEvent.SubscriptionDowngraded,
        TrackedEvent.WorkspaceCreated,
        TrackedEvent.StorymapCollaboratorInvited,
        TrackedEvent.WorkspaceMemberInvited,
    ];

    public supportedPages = [
        TrackedPage.UserDashboard,
        TrackedPage.WorkspaceDashboard,
        TrackedPage.Storymap,
        TrackedPage.UpgradeSubscription,
        TrackedPage.ManageJiraIntegrationSettings,
    ];
}
